import Vue from 'vue';

export default {
  // 获取轮播
  getAdvertisingList(params) {
    return Vue.axios.get('/api/v1.0/system/carrousel/list', {params});
  },
  // 获取分页表格数据
  getTableListByPage(postData) {
    return Vue.axios.post('/api/dashboard/1.0/order/selectOrderListByPage', postData);
  }
};
